import { ConsultantLanding } from "./components/landing/ConsultantLanding.jsx";
import { LegalDocument } from "./components/legal/LegalDocument.jsx";
import { legalPageForPath } from "./lib/legalRoutes.js";

export default function App() {
  const legalPage = legalPageForPath(window.location.pathname);
  if (legalPage) return <LegalDocument page={legalPage} />;

  return <ConsultantLanding />;
}
